import { useEffect } from 'react';

import { AppRoutes } from 'config';
import { useNavigate } from 'hooks';
import { ButtonColors } from 'types';
import { Icon } from 'components/icon';
import { Popup } from 'components/popup';
import { Button } from 'components/button';
import { useAppDispatch, useAppSelector } from 'store';
import {
  fetchNotifications,
  notificationsStore,
} from 'store/slices/notifications';

import * as Styles from './styles';
import { NotificationCard } from './card';
import { NotificationHeader } from './header';

export const NotificationsPopup = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isLoading, unreadCount, notifications } =
    useAppSelector(notificationsStore);

  useEffect(() => {
    dispatch(fetchNotifications());
  }, []);

  return (
    <Popup
      removeAutofocus
      position={['bottom center', 'bottom left', 'bottom right']}
      trigger={
        <Styles.StyledButton
          padding="0"
          transparent
          icon={<Icon.Bell />}
          disabled={isLoading}
          hasUnreadCount={!!unreadCount}
          colorType={ButtonColors.BlackWhite}
        />
      }
    >
      {(close) =>
        notifications?.length ? (
          <Styles.Container>
            <NotificationHeader isDialog unreadCount={unreadCount} />
            <Styles.Content>
              {notifications.map((notification, i) => (
                <NotificationCard
                  isDialog
                  close={close}
                  showDivider={i > 0}
                  key={notification.id}
                  notification={notification}
                />
              ))}
            </Styles.Content>

            <Button
              transparent
              padding="16px"
              text="View all"
              colorType={ButtonColors.LightBlue}
              onClick={() => {
                close();
                navigate(AppRoutes.Notifications.Home);
              }}
            />
          </Styles.Container>
        ) : (
          <Styles.StyledPlaceholder text="No notifications" />
        )
      }
    </Popup>
  );
};

export { NotificationCard, NotificationHeader };
